import {Box, CircularProgress, LinearProgress, Stack, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useTheme} from '@mui/material/styles';
import BasePage from "../../baseComponents/BasePage";
import StateContainer from "./StateContainer";
import {getSimulation, patchSimulation, postSession} from "../../../utils/api";
import MasDatabase from "./MasDatabase";
import DatabaseFilters from "./DatabaseFilters";
import CurrentSimulation from "./CurrentSimulation";
import Button from "@mui/material/Button";
import {downloadZippedData} from "../../../utils/helpers";
import {LinksIconMenu} from "../resources/LinksIconMenu";

const DataAccessPage = ({id, setId}) => {
  const [corId, setCorId] = useState([])
  const [corData, setCorData] = useState([])
  const [params, setParams] = useState({domain: null, toi: null, state: null, files: []})
  const [submitError, setSubmitError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    postSession(id)
      .then(response => {
        const returnId = response.data.key_id.toString()
        localStorage.setItem('id', returnId);
        setId(returnId)
        getSimulation(returnId)
          .then((response) => {
            const {data} = response;
            if (data && data.cor_id) {
              setCorId([data.cor_id])
              setParams(prevState => ({...prevState, domain: data.domain, toi: data.time_of_interest}))
            }
          })
          .catch((error) => {
          })
      })
      .catch(error => {
      });
  }, []);

  useEffect(() => {
    const cid = Array.isArray(corId) ? corId[0] : corId;      // handle either shape
    if (cid == null || cid === '') { // not ready yet
      return;
    }
    const corIdNumeric = Number(cid); // or keep as string if your API expects that

    const apiparams = {
      cor_id: corIdNumeric,
    };

    patchSimulation(id, apiparams).catch(console.error);
  }, [id, corId]);

  useEffect(() => {
    const apiparams = {
      domain: params.domain,
      time_of_interest: params.toi ?? null,
    };

    patchSimulation(id, apiparams).catch(console.error);
  }, [params.domain, params.toi]);

  const submitData = () => {
    if (!params.domain || !params.state || params.files.length === 0) {
      setSubmitError('Please select a domain, state of interest, and at least one data file.')
    } else {
      let validFiles = params.files.filter(file => file !== 'ALL')
      if (validFiles.length === 0) {
        setSubmitError('Please select at least one data file.')
      } else {
        setSubmitError('')
        const apiparams = {
          cor_id: corId[0],
          domain: params.domain,
          state: params.state,
          files: validFiles,
        }
        downloadZippedData(apiparams, setIsLoading)
      }
    }
  }

  return (
    <BasePage>
      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
        <LinksIconMenu sx={{width: 100, justifyContent: 'right'}}/>
      </Box>
      <Stack
        spacing={1}
        sx={{
          width: '100%',
          minWidth: 0,
          minHeight: '560',
          flexGrow: 1,
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            border: '2px solid #ccc',
            borderRadius: '8px',
            bgcolor: 'white',
            p: '10px',
            overflow: 'auto',
            width: '100%',
          }}
        >
          <MasDatabase corId={corId} setCorId={setCorId} corData={corData} />
        </Box>

        <StateContainer label={'DATABASE FILTERS'}>
          <DatabaseFilters setCorData={setCorData} />
        </StateContainer>

        <StateContainer label={'SELECTED SIMULATION'}>
          <CurrentSimulation corId={corId} params={params} paramSetter={setParams}/>
        </StateContainer>

        <Button
          onClick={submitData}
          variant={'contained'}
          sx={{
            width: '200px',
            height: '50px',
            fontSize: '14px',
          }}
          color={'secondary'}
          fullWidth={true}
          disabled={isLoading}
        >
          {isLoading ? 'Downloading...' : 'Download Data'}
        </Button>
        {submitError &&
          <Typography
            fontSize={12}
            color={'error.main'}
            sx={{width: '100%', textAlign: 'center'}}
          >
            {submitError}
          </Typography>
        }
        {isLoading && (
          <LinearProgress
            sx={{marginBottom: '2px', marginLeft: '5px', width: '200px'}}
          />
        )}
      </Stack>
    </BasePage>
  );
};


export default DataAccessPage;